// Factories
import { BaseLogicModuleFactory } from "../../base/factories/BaseLogicModuleFactory";
/** Factory class for modules in Teams app */
export class TeamsLogicModuleFactory extends BaseLogicModuleFactory {
}
